import { Icon } from 'lmcv/components/Icon'

import * as S from './styled'

const ModalShareError = ({ onClick, onClose }) => {
  return (
    <S.Wrapper>
      <S.ModalClose onClick={onClose}>
        <Icon name="close_tiny" width="18px" height="18px" />
      </S.ModalClose>

      <S.Title>Você precisa ter clientes ativos para compartilhar cupons</S.Title>
      <S.Description>Para enviar cupons, você precisa ter ao menos um Cliente ativo. <br/>Você pode adicioná-lo na página Meus Clientes, assim que o seu Cliente aceitar o convite, você poderá enviar cupons de desconto.</S.Description>

      <S.Button onClick={onClick} color="green" isBlock isRounded>Ir para Meus Clientes</S.Button>
    </S.Wrapper>
  )
}

export default ModalShareError
